<template>
  <div class="prescription">
    <div class="bg_fff pt10 pb10 pl15 pr15">
      <el-row>
        <el-button type="primary" v-if="!reSub" @click="submitPrescription"
          >保存处方</el-button
        >
        <el-button type="primary" style="float: right" @click="shareClick"
          >共享处方查阅</el-button
        >
      </el-row>
    </div>
    <div class="mt10 flex jcb">
      <div :class="display ? 'width100 bg_fff' : 'width70 bg_fff'">
        <el-form label-width="100px">
          <label
            style="
              font-weight: bold;
              margin-bottom: 20px;
              display: block;
              margin-left: 20px;
            "
            >基本信息</label
          >
          <el-row>
            <el-col :span="8">
              <el-form-item label="姓名">
                <el-input v-model="userobj.hzxm" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="性别">
                <el-input :value="getSex(userobj.zjhm)" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="年龄">
                <el-input v-model="userobj.age" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="手机号码">
                <el-input v-model="userobj.sjh" :disabled="true"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="证件号码">
                <el-input :value="userobj.zjhm" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="就诊科室">
                <el-input :value="userobj.ksmc" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="mt10 flex jcb">
      <div :class="display ? 'width100 bg_fff' : 'width70 bg_fff'">
        <el-form label-width="100px">
          <label
            style="
              font-weight: bold;
              margin-bottom: 20px;
              display: block;
              margin-left: 20px;
            "
            >处方信息</label
          >
          <el-row>
            <el-col :span="8">
              
              <el-form-item label="过敏史：">
                <el-autocomplete
                  style="width: 300px"
                  v-model="allergyHistoryValue"
                  size="mini"
                  :fetch-suggestions="allergy"
                  @select="
                    (selectItem) => {
                      allergyHandleSelect(selectItem);
                    }
                  "
                  @keydown.native="deleteAllergyHistory"
                ></el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- v-model="tabsList[idx].allergyHistoryValue" -->
              <el-form-item label="诊断：">
                <el-autocomplete
                  style="width: 300px"
                  size="mini"
                  :fetch-suggestions="allergy"
                  @select="
                    (selectItem) => {
                      allergyHandleSelect(selectItem);
                    }
                  "
                  @keydown.native="deleteAllergyHistory"
                ></el-autocomplete>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div v-if="showGrass">
          <el-form label-width="100px">
            <label
              style="
                font-weight: bold;
                margin-bottom: 20px;
                display: block;
                margin-left: 20px;
                color: #f00;
              "
              >请选择草药方信息</label
            >
            <el-row>
              <el-col :span="8">
                <el-form-item label="给药途径：">
                  <el-select
                    v-model="GrassRoad"
                    placeholder="请选择给药途径"
                    style="width: 300px"
                  >
                    <el-option
                      v-for="item in drugAdmissionList"
                      :key="item.id"
                      :label="item.dicName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="用药频率：">
                  <el-select
                    v-model="GrassFrequency"
                    placeholder="请选择用药频率"
                    style="width: 300px"
                  >
                    <el-option
                      v-for="item in drugFrequencyList"
                      :key="item.id"
                      :label="item.dicName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="草药贴数：">
                  <el-input v-model="tieshu"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <div class="section sectionBox">
          <el-card class="box-card" v-for="(item, index) in newDurgData" :key="index">
            <div slot="header" class="clearfix">
              <span>{{
                item.type == "Western" ? item.WesternName : item.grassName
              }}</span>
              <i
                class="el-icon-delete"
                style="float: right"
                @click="remover(item, index)"
              ></i>
              <i class="el-icon-edit" style="float: right; margin-right: 20px"></i>
            </div>
            <div  class="content">
              规格:{{item.guige}}
            </div>
            <div  class="content">
              用法用量:{{item.type=="Western"?item.pinlvText:item.fujia}}
            </div>
            <div  class="content">
              数量:<el-input-number v-model="item.WesternNum" @change="handleChange" :min="1" :max="item.kucun"></el-input-number>
            </div>
          </el-card>
          <el-card class="box-card" @click.native="addWestern()">
            <div
              slot="header"
              class="clearfix"
              style="text-align: center; font-weight: bold"
            >
              <span>添加西药|中成药</span>
            </div>
            <i
              class="el-icon-circle-plus-outline"
              style="font-size: 100px; margin: 0 auto"
            ></i>
          </el-card>
          <el-card class="box-card" @click.native="addGrass()">
            <div
              slot="header"
              class="clearfix"
              style="text-align: center; font-weight: bold"
            >
              <span>添加中草药</span>
            </div>

            <i
              class="el-icon-circle-plus-outline"
              style="font-size: 100px; margin: 0 auto"
            ></i>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 中西药dialog -->
    <el-dialog
      title="添加西药|中成药"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <el-form ref="Westernform" :model="WesternForm" label-width="80px" :rules="rules">
        <el-form-item label="药品名称" prop="WesternName">
          <el-autocomplete
            :trigger-on-focus="false"
            style="width: 300px"
            size="mini"
            v-model="WesternForm.WesternName"
            :fetch-suggestions="fetchMedicine"
            @select="
              (selectItem) => {
                handleSelect(selectItem);
              }
            "
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="规格">
          <el-input v-model="WesternForm.guige" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="单价">
          <el-input v-model="WesternForm.price" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="用药频率" prop="pinlv">
          <el-select
            v-model="WesternForm.pinlv"
            placeholder="请选择用药频率"
            style="width: 300px"
            @change="changePinlv"
          >
            <el-option
              v-for="item in drugFrequencyList"
              :key="item.id"
              :label="item.dicName"
              :value="item.dicCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单次剂量" prop="jiliang">
          <el-input
            v-model="WesternForm.jiliang"
            style="width: 100px; margin-right: 10px"
          ></el-input
          >{{ WesternForm.doseUnit }}
        </el-form-item>
        <el-form-item label="给药途径" prop="tujing">
          <el-select
            v-model="WesternForm.tujing"
            placeholder="请选择给药途径"
            style="width: 300px"
          >
            <el-option
              v-for="item in drugAdmissionList"
              :key="item.id"
              :label="item.dicName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量">
          <el-input-number
            v-model="WesternForm.number"
            :min="1"
            :max="10"
            label="请输入单次剂量"
          ></el-input-number>
          <!-- @change="handleChange" -->
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">添加</el-button>
          <el-button @click="cancel('WesternForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 草药dialog -->
    <el-dialog title="添加中草药" :visible.sync="grassVisible" width="30%" center>
      <el-form ref="grassform" :model="grassForm" label-width="80px" :rules="grassrules">
        <el-form-item label="药品名称" prop="grassName">
          <el-autocomplete
            :trigger-on-focus="false"
            style="width: 300px"
            size="mini"
            v-model="grassForm.grassName"
            :fetch-suggestions="HerbsfetchMedicine"
            @select="
              (selectItem) => {
                HerbshandleSelect(selectItem);
              }
            "
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="规格">
          <el-input v-model="grassForm.guige" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="单价">
          <el-input v-model="grassForm.price" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="附加" prop="fujia">
          <el-select
            v-model="grassForm.fujia"
            placeholder="请选择附加"
            style="width: 300px"
            @change="changefujia(grassForm.fujia)"
          >
            <el-option
              v-for="item in singleDoseList"
              :key="item.id"
              :label="item.dicName"
              :value="item.dicName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单次剂量" prop="jiliang">
          <el-input
            v-model="grassForm.jiliang"
            style="width: 100px; margin-right: 10px"
          ></el-input
          >{{ grassForm.doseUnit }}
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="grassSubmit">添加</el-button>
          <el-button @click="grassCancel('grassForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 共享处方 -->
    <el-drawer :visible.sync="dialogVisible" size="80%">
      <el-table :data="gridData">
        <el-table-column
          width="150"
          property="tradedate"
          label="开方日期"
        ></el-table-column>
        <el-table-column
          width="200"
          property="miname"
          label="医疗机构名称"
        ></el-table-column>
        <el-table-column
          width="100"
          property="tradecuretype"
          label="医疗类别"
        ></el-table-column>
        <el-table-column
          width="100"
          property="tradefundtype"
          label="险种类型"
        ></el-table-column>
        <el-table-column
          property="recipeno"
          label="处方号码"
          width="250"
        ></el-table-column>
        <el-table-column property="diag" label="处方诊断" width="150"></el-table-column>
        <el-table-column label="详情" width="130">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click.prevent="getDetails(scope.row)"
              >处方详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-drawer size="70%" :append-to-body="true" :visible.sync="innerDrawer">
        <el-table :data="durgData">
          <el-table-column property="fee_type" label="费用类别"></el-table-column>
          <el-table-column property="itemname" label="名称"></el-table-column>
          <el-table-column property="specification" label="规格"></el-table-column>
          <el-table-column property="dose" label="剂型"></el-table-column>
          <el-table-column property="unitprice" label="单价"></el-table-column>
          <el-table-column property="count" label="数量"></el-table-column>
          <el-table-column property="unit" label="单位"></el-table-column>
          <el-table-column property="dosage" label="一次剂量"></el-table-column>
          <el-table-column property="minpackage" label="剂量单位"></el-table-column>
          <el-table-column property="howtouse" label="用法"></el-table-column>
          <el-table-column property="days" label="天数"></el-table-column>
          <el-table-column property="fee" label="总金额"></el-table-column>
        </el-table>
      </el-drawer>
    </el-drawer>
  </div>
</template>

<script>
import axiosUtil from "../../utils/AxiosUtils.js";
import { tokenCache } from "../../../cache/tokenCache";
import { sexFilter } from "../../lib/filters";
import { timeFormat, isEmpty } from "../../lib/utils";

const PAGE = {
  pageNum: 1,
  pageSize: 5,
  pages: 1,
  total: 0,
};
export default {
  data() {
    return {
      GrassFrequency: "", //草药用药频率
      GrassRoad: "", //草药给药途径
      singleDoseList: [],
      allergyHistoryValue:'',
      allergyHistoryNmae:'',
      grassForm: {
        type: "grass",
        drugCode: "",
        grassName: "",
        guige: "",
        price: "",
        fujia: "",
        jiliang: "",
        doseUnit: "",
      },
      grassVisible: false,
      durgData: [],
      innerDrawer: false,
      gridData: [],
      dialogVisible: false,
      drugFrequencyList: [], //频次
      drugAdmissionList: [], //用法
      reSub: false,
      display: true,
      WesternForm: {
        type: "Western",
        drugCode: "",
        WesternName: "",
        WesternNum: 1,
        guige: "",
        pinlv: "",
        jiliang: "",
        tujing: "",
        number: "",
        price: "",
        doseUnit: "",
        pinlvText:''
      },
      centerDialogVisible: false,
      tieshu: 1,
      showGrass: false,
      value: "",
      newDurgData: [],
      allergyList:[],
      allergyIdx:0,
      grassrules: {
        grassName: [{ required: true, message: "请选择药品名称", trigger: "change" }],
        fujia: [{ required: true, message: "请选择附加", trigger: "change" }],
        jiliang: [{ required: true, message: "请输入药品剂量", trigger: "blur" }],
      },
      rules: {
        WesternName: [{ required: true, message: "请选择药品名称", trigger: "change" }],
        pinlv: [{ required: true, message: "请选择用药频率", trigger: "change" }],
        jiliang: [{ required: true, message: "请输入药品剂量", trigger: "blur" }],
        tujing: [{ required: true, message: "请选择给药途径", trigger: "change" }],
      },
    };
  },
  filters: {
    sexFilter,
    timeFormat,
  },
  props: ["userobj"],
  mounted() {
    this.getPatientInfo();
  },
  methods: {
    remover(item, index) {
      let that = this;
      this.newDurgData.splice(index, 1);
      this.newDurgData.forEach((label) => {
        if (label.type != "grass") {
          that.showGrass = false;
        } else {
          that.showGrass = true;
        }
      });
    },
    grassSubmit() {
      let that = this;
      that.showGrass == false ? (that.showGrass = true) : "";
      that.$refs.grassform.validate((valid) => {
        if (valid) {
          that.newDurgData.push(that.grassForm);
          that.newDurgData = JSON.parse(JSON.stringify(that.newDurgData));
          that.$refs.grassform.resetFields();
          that.grassForm.price = "";
          that.grassForm.guige = "";
          that.grassForm.drugCode = "";
          that.grassForm.doseUnit = "";
          that.grassVisible = false;
          console.log(that.newDurgData);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changefujia(fujia) {
      console.log(fujia);
    },
    changePinlv(e) {
      let that=this;
      that.drugFrequencyList.forEach((item,index)=>{
          if(item.dicCode==e){
            that.WesternForm.pinlvText=item.dicName
          }
      })
      console.log(e);
    },
    grassCancel(formName) {
      this.$refs.grassform.resetFields();
      this.grassForm.price = "";
      this.grassForm.guige = "";
      this.grassForm.drugCode = "";
      this.grassForm.doseUnit = "";
      this.newDurgData = JSON.parse(JSON.stringify(this.newDurgData));
      this.grassVisible = false;
    },
    cancel(formName) {
      this.$refs.Westernform.resetFields();
      this.WesternForm.price = "";
      this.WesternForm.guige = "";
      this.newDurgData = JSON.parse(JSON.stringify(this.newDurgData));
      console.log(this.newDurgData, "1111");

      this.centerDialogVisible = false;
    },
    onSubmit() {
      let that = this;
      that.$refs.Westernform.validate((valid) => {
        if (valid) {
          that.newDurgData.push(that.WesternForm);
          that.newDurgData = JSON.parse(JSON.stringify(that.newDurgData));
          that.$refs.Westernform.resetFields();
          that.WesternForm.price = "";
          that.WesternForm.guige = "";
          console.log(that.newDurgData);
          that.centerDialogVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addGrass() {
      this.grassVisible = true;
    },
    addWestern() {
      this.centerDialogVisible = true;
      console.log(this.WesternForm);
    },
    getSex(idCardNum) {
      if (!idCardNum) return;
      let date = new Date();
      let year = date.getFullYear();
      this.age = year - idCardNum.substring(6, 10);
      if (idCardNum.substring(16, 17) % 2 == 0) {
        return "女";
      } else return "男";
    },
    getDetails(row) {
      this.durgData = row.itemlist.item;
      this.innerDrawer = true;
    },
    shareClick() {
      let that = this;
      axiosUtil(
        {
          service: "smarthos.yygh.ApiyGHpaymentService.prescription.record",
          ddid: that.userobj.ddid,
          orgid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
          token: tokenCache.get(),
        },
        ({ code, recipeList, msg }) => {
          if (code == "0") {
            that.gridData = recipeList;
            that.dialogVisible = true;
          }
        }
      );
    },
    handleClose() {
      this.dialogVisible = false;
    },
    initprescriptionList(bizId) {
      let that = this;
      axiosUtil(
        {
          service: "smarthos.recipe.order.opendoc.list.page.diagnosis",
          bizId: bizId,
          status: "REBACK",
          token: tokenCache.get(),
        },
        ({ code, list, msg }) => {
          if (code == "0") {
            for (let i in list) {
              list[i].diagnosisListData = [];
              for (let j in list[i].diagnosisList) {
                list[i].diagnosisList[j].checked = false;
              }
            }
            that.prescriptionList = list;
          }
        }
      );
    },
    async getPatientInfo() {
      const ddId = this.userobj.ddid;
      // const ddId = '10001467'
      // const ddId = "10001506"
      const { code, obj } = await this.$http("smarthos.online.outpatient.pack.info", {
        id: ddId,
      });
      this.patientInfo = obj.userInfo;
      this.patientInfo.jzkh = obj.ddxx.obj.jzkh;
      this.getMedicineParams();
    },
    async getMedicineList(key) {},
    async allergy(queryString, cb) {
      let that=this;
      const index = queryString.lastIndexOf(";");
      const key = queryString.substring(index + 1, queryString.length);
      if(key==''&&JSON.stringify(that.allergyList)!='[]'){
        cb(that.allergyList);
        return
      }
      const options = {
        hosid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
        drugName: key,
        pagenum: "1",
        pagesize: "100",
        token: tokenCache.get(),
      };
      let { code, drugList } = await this.$http(
        "smarthos.yygh.allergic.history.page.list",
        options
      );
      if (code == "0") {
        for (let i of drugList) {
          i.value = i.drugName; //必须绑定value值作为显示数据
        }
        that.allergyList=drugList;
        cb(drugList);
      }
    },
    async HerbsfetchMedicine(queryString, cb) {
      const options = {
        drugType: "CHINESE",
        hosid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
        drugName: this.grassForm.grassName,
        token: tokenCache.get(),
      };
      let { code, drugEntityList } = await this.$http(
        "smarthos.yygh.medical.list.by.name",
        options
      );
      if (code == "0") {
        for (let i of drugEntityList) {
          i.value = i.name + " " + i.originPlace; //必须绑定value值作为显示数据
        }
        cb(drugEntityList);
      }
    },
    async fetchMedicine(queryString, cb) {
      const options = {
        drugName: queryString,
        hosId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
        drugType: "WESTERNPRESCRIPT",
        token: tokenCache.get(),
        // ...this.page,
      };
      let { code, drugEntityList } = await this.$http(
        "smarthos.yygh.medical.list.by.name",
        options
      );
      if (code == "0") {
        for (let i of drugEntityList) {
          i.value = i.name + " " + i.originPlace; //必须绑定value值作为显示数据
        }
        cb(drugEntityList);
      }
    },
    async fetchDiagnosis(queryString, cb) {
      let that = this;
      const index = queryString.lastIndexOf(";");
      const key = queryString.substring(index + 1, queryString.length);
      if (key == "" && JSON.stringify(that.diagnosisList) != "[]") {
        cb(that.diagnosisList);
        return;
      }
      const options = {
        diagname: key,
        pageSize: "100",
        pageNum: "1",
        token: tokenCache.get(),
      };
      let { code, diagnosisList } = await this.$http(
        "smarthos.yygh.select.diagnostic.dictionary.info.list.new",
        options
      );
      if (code == "0") {
        if (diagnosisList) {
          let list = diagnosisList;
          for (let i of list) {
            i.value = i.diagnosisName; //必须绑定value值作为显示数据
          }
          that.diagnosisList = list;
          cb(list);
        }
      }
    },
    async fetchDiagnosis1(queryString, cb) {
      let that = this;
      const index = queryString.lastIndexOf(";");
      const key = queryString.substring(index + 1, queryString.length);
      if (key == "" && JSON.stringify(that.diagnosisList1) != "[]") {
        cb(that.diagnosisList1);
        return;
      }
      const options = {
        qKey: key,
        pageNum: "1",
        token: tokenCache.get(),
      };
      let { code, obj } = await this.$http(
        "smarthos.drugs.online.diagnosis.query",
        options
      );
      if (code == "0") {
        if (obj.list) {
          let list = obj.list;
          for (let i of list) {
            i.value = i.dicName; //必须绑定value值作为显示数据
          }
          that.diagnosisList1 = list;
          cb(list);
        }
      }
    },
    HerbshandleSelect(item) {
      this.grassForm.grassName = item.name;
      this.grassForm.drugCode = item.drugCode;
      this.grassForm.doseUnit = item.doseUnit;
      this.grassForm.guige = item.specification;
      this.grassForm.price = item.price;
      this.grassForm.jiliang = item.dose;
    },
    handleSelect(item) {
      this.WesternForm.WesternName = item.name;
      this.WesternForm.doseUnit = item.doseUnit;
      this.WesternForm.drugCode = item.drugCode;
      this.WesternForm.guige = item.specification;
      this.WesternForm.price = item.price;
      this.WesternForm.jiliang = item.dose;
    },
    allergyHandleSelect(item) {
      
      if(this.allergyIdx==0){
        this.allergyHistoryValue=item.drugName+';';
        this.allergyHistoryNmae=item.drugName+';';
        this.allergyIdx++;
      }else{
        this.allergyHistoryNmae=this.allergyHistoryNmae+item.drugName+';';
        this.allergyHistoryValue=this.allergyHistoryNmae;
        this.allergyIdx++;
      }
    },
    selectDiagnose(item) {
      if (this.tabsList[this.idx].diagnosisName != "") {
        let n = this.tabsList[this.idx].diagnosisName.split(";").length;
        if (n <= 10) {
          this.tabsList[this.idx].diagnosisName =
            this.tabsList[this.idx].diagnosisName + item.diagnosisName + ";";
          this.tabsList[this.idx].diagnosisValue = this.tabsList[this.idx].diagnosisName;
          this.tabsList[this.idx].diagnosisArray.push(item.diagnosisName);
        } else {
          this.tabsList[this.idx].diagnosisValue = this.tabsList[this.idx].diagnosisName;
          this.$message.error("输入诊断数量不能超过10个！");
        }
      } else {
        this.tabsList[this.idx].diagnosisArray.push(item.diagnosisName);
        this.tabsList[this.idx].diagnosisName = item.diagnosisName + ";";
        this.tabsList[this.idx].diagnosisValue = item.diagnosisName + ";";
      }
    },
    deleteAllergyHistory(e) {
      if (e.keyCode && e.keyCode === 8) {
        let array=this.allergyHistoryValue.split(';').filter(item=>item!='');
        array=array.filter((element, index) => index < array.length - 1);
        this.allergyHistoryValue=array.join(';')+';';
        this.allergyHistoryNmae=array.join(';')+';';
        console.log(this.allergyHistoryValue)
      }
    },
    async getMedicineParams() {
      const { code, obj } = await this.$http(
        "smarthos.drugs.online.prescription.dictionary",
        {}
      );
      this.drugAdmissionList = obj.drugUsageList;
      for (let i of obj.useFrequencyList) {
        i.frequencyObj = i.dicName;
      }
      this.drugFrequencyList = obj.useFrequencyList;
      this.singleDoseList = obj.herbSubjoinList;
    },
    addTab(targetName) {
      if (targetName == "1") {
        const index = ++this.tabIndex;
        let newTabName = index + "";
        this.tabsList.push({
          title: "西成药方" + newTabName,
          name: newTabName,
          orderType: "WESTERN_RECIPE",
          allergyHistory: this.tabsList[this.idx].allergyHistory,
          diagnosisName: this.tabsList[this.idx].diagnosisName,
          diagnosisValue: this.tabsList[this.idx].diagnosisValue,
          drugList: [{}],
          repeatDrugId: [],
          allergyHistoryId: this.tabsList[this.idx].allergyHistoryId,
          allergyHistoryValue: this.tabsList[this.idx].allergyHistoryValue,
          diagnosisArray: this.tabsList[this.idx].diagnosisArray,
        });
        this.activeTab = newTabName;
        this.idx = this.tabsList.length - 1;
      } else if (targetName == "3") {
        const index = ++this.tabIndex;
        let newTabName = index + "";
        this.tabsList.push({
          title: "草药方" + newTabName,
          name: newTabName,
          orderType: "CHINESE_RECIPE",
          allergyHistory: this.tabsList[this.idx].allergyHistory,
          diagnosisName: this.tabsList[this.idx].diagnosisName,
          diagnosisValue: this.tabsList[this.idx].diagnosisValue,
          tcmDosage: "1",
          drugList: [{}],
          repeatDrugId: [],
          allergyHistoryId: this.tabsList[this.idx].allergyHistoryId,
          allergyHistoryValue: this.tabsList[this.idx].allergyHistoryValue,
          diagnosisArray: this.tabsList[this.idx].diagnosisArray,
        });
        this.activeTab = newTabName;
        this.idx = this.tabsList.length - 1;
      }
    },
    tabChange() {
      this.idx = this.activeTab - 1;
    },
    removeTab(targetName) {
      this.$confirm(
        `是否确定删除${
          this.tabsList[targetName - 1].title
        },删除后不可恢复，仍要继续该操作？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let tabs = this.tabsList;
          let activeName = this.activeTab;
          if (activeName === targetName) {
            tabs.forEach((tab, index) => {
              if (tab.name === targetName) {
                let nextTab = tabs[index + 1] || tabs[index - 1];
                if (nextTab) {
                  activeName = nextTab.name;
                }
              }
            });
          }
          this.activeTab = activeName;
          this.tabsList = tabs.filter((tab) => tab.name !== targetName);
          this.idx = this.tabsList.length - 1;
          // this.$message({
          //   type: "success",
          //   message: "删除成功!",
          // });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getCurrentTime() {
      //获取当前时间并打印
      var _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let gettime = yy + "-" + mm + "-" + dd;
      return gettime;
    },
    async submitPrescription() {
      let that = this;
      const load = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let diagnosisList = [];
      let prescriptionDetailList = [];
      let tcmDosage = "";
      for (let i in this.tabsList) {
        for (let u in this.tabsList[i].drugList) {
          let obj = {};
          obj.code = this.tabsList[i].drugList[u].drugCode;
          obj.count = this.tabsList[i].drugList[u].amount;
          obj.dose = this.tabsList[i].drugList[u].dose;
          obj.frequency = this.tabsList[i].drugList[u].dicCode;
          obj.usage = this.tabsList[i].drugList[u].admissionId;
          obj.name = "";
          obj.unit = "";
          obj.doseUnit = "";
          obj.price = this.tabsList[i].drugList[u].price;
          if (this.tabsList[i].drugList[u].attachId) {
            obj.attachName = this.tabsList[i].drugList[u].attachId;
          }
          if (this.tabsList[i].orderType == "WESTERN_RECIPE") {
            obj.prescriptionCount = "1";
            tcmDosage = "";
          } else {
            obj.prescriptionCount = this.tabsList[i].tcmDosage;
            tcmDosage = this.tabsList[i].tcmDosage;
          }
          prescriptionDetailList.push(obj);
        }
        let diagnosis = this.tabsList[i].diagnosisName.split(";");
        for (let j = 0; j < diagnosis.length - 1; j++) {
          if (JSON.stringify(diagnosisList) != "[]") {
            for (let o in diagnosisList) {
              if (diagnosisList[o].diagnosisName == diagnosis[j]) {
              }
            }
          } else {
            let obj = {};
            obj.diagnosisName = diagnosis[j];
            obj.ICD10Code = "";
            obj.diagnosisRemark = "";
            diagnosisList.push(obj);
          }
        }
      }

      const options = {
        hosId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
        bookId: this.userobj.ddid,
        prescriptionDate: that.getCurrentTime(),
        diagnosisList: JSON.stringify(diagnosisList),
        prescriptionDetailList: JSON.stringify(prescriptionDetailList),
        allergicDrugs: this.tabsList[this.idx].allergyHistory,
        patId: that.patientInfo.patId,
        compatId: that.patientInfo.compatId,
        compatAddress: that.patientInfo.areaName,
        patientNumber: that.patientInfo.jzkh,
        allergyHistoryList: this.tabsList[this.idx].allergyHistoryId,
        token: tokenCache.get(),
        tcmDosage: tcmDosage,
      };
      const { code, obj, msg } = await this.$http(
        // "smarthos.yygh.bjyl.prescription.medical.check",
        "smarthos.recipe.prescription.medical.check",
        options
      );
      load.close();
      if (code == "0") {
        that.$message({
          type: "success",
          message: "保存成功,请前往处方列表签名",
        });
        that.$router.push({ path: "/main/prescription-list" });
      }
    },
    async reSubPrescription(id) {
      this.fullscreenLoading = true;
      const options = {
        orderId: this.$route.query.rpId,
        patId: this.patientInfo.patId,
        compatId: this.patientInfo.compatId,
        compatName: this.patientInfo.compatName,
        compatGender: this.patientInfo.compatGender,
        compatMobile: this.patientInfo.compatMobile,
        compatAge: this.patientInfo.compatAge,
        compatAddress: "",
        bizId: this.$route.query.bizId,
        type: "2",
        recipeOrderList: this.tabsList,
        patientNumber: this.patientNumber,
        token: tokenCache.get(),
      };
      const { code, obj } = await this.$http(
        "smarthos.recipe.order.fenghuang.new.add",
        // "smarthos.recipe.order.add.new",
        options
      );
      this.fullscreenLoading = false;
      if (code == "0") {
        if (obj.recipeOrderList) {
          this.dialogVisible = true;
          this.initprescriptionList(obj.bizId);
        } else {
          this.$message({
            type: "success",
            message: "保存成功,请前往处方列表签名",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss">
.prescription {
  .el-form {
    padding-top: 22px;
    border-top: 1px solid #f5f5f5;
  }
  .el-table {
    margin-top: 15px;
  }
  .pagination-wrapper {
    padding: 20px 0;
  }
  .el-table .cell {
    max-height: 69px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
.record-item {
  padding: 15px 15px;
  .record-item-title {
    span {
      width: 4px;
      height: 14px;
      background-color: #3692f9;
      margin-right: 10px;
    }
  }
  .record-item-content {
    padding: 5px 15px;
    font-size: 14px;
    color: #999999;
  }
}

.info-label {
  font-size: 14px;
  color: #333333;
}

.info-item {
  font-size: 14px;
  color: #666666;
  margin-right: 60px;
  border-bottom: 1px solid #333333;
  padding: 0 10px;
}
.el-input--mini .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.info-item1 {
  font-size: 14px;
  color: red;
  margin-right: 60px;
  border-bottom: 1px solid #333333;
  padding: 0 10px;
}
.contentView {
  display: flex;
  align-items: center;
  justify-content: center;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.sectionBox {
  width: 100%;
  height: auto;
  margin: 20px 20px 40px 20px;
  overflow: auto;
}
.section:active {
  display: block;
  content: "";
  clear: both;
}
.box-card {
  width: 300px;
  height: 200px;
  float: left;
  margin: 15px;
}
.el-card__body {
  display: flex;
  align-items: center;
  justify-content: center;
}
.content {
  font-size: 14px;
  margin-bottom: 18px;
}
.un-sel {
  display: inline-block;
  width: 15px;
  height: 15px;
  border: 1px solid #3692f9;
  border-radius: 50%;
}

.selected {
  background-color: #3692f9;
}

.el-table__header-wrapper {
  .cell {
    label.el-checkbox {
      display: none !important;
    }
  }
}

.medicine-table {
  padding: 0 5px;
  height: 70%;
  overflow-y: auto;
  .el-table__header-wrapper {
    .cell {
      font-size: 14px;
      font-weight: normal;
      color: #000;
    }
  }
}

.sign {
  width: 65px;
  height: 25px;
  position: absolute;
  top: 30px;
  left: 70px;
  color: white;
  background-color: red;
  border-radius: 2px;
  text-align: center;
  transform: rotateZ(-45deg);
}
.signC {
  background-color: #ffffff;
  border: 1px solid #58a4fa;
  color: #58a4fa;
}

</style>
